import ApiService from '@core/api/services/ApiService';
import UrlResolver from '@core/url-resolver/UrlResolver';
import { RootState } from '@state/ducks';
import {
  ProductDetailAction,
  SET_AVAILABLE_DOWNLOADS,
  SET_AVAILABLE_DOWNLOADS_LOADING,
} from '@state/ducks/productdetail/productdetail.reducer';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VariantDownload } from './Downloads.hybrid';

export interface ProductDownloadsRequest {
  modelAgilityId: number;
  variantAgilityId: number;
  cultureCode: string;
  published: boolean;
}

function fetchDownloads(
  modelAgilityId: number | null,
  variantAgilityId: number | null,
  cultureCode: string,
  published: boolean,
): Promise<VariantDownload[]> {
  if (variantAgilityId === null) {
    return Promise.resolve([]);
  }
  if (modelAgilityId === null) {
    return Promise.resolve([]);
  }

  const params: ProductDownloadsRequest = {
    modelAgilityId,
    variantAgilityId,
    cultureCode,
    published,
  };

  return ApiService.request<VariantDownload[]>({
    method: 'GET',
    baseUrl: UrlResolver.getDomain(),
    controller: 'product-detail',
    slug: 'product-downloads',
    params,
  });
}

export const useVariantDownloads = (): boolean => {
  const modelAgilityId = useSelector<RootState, number | null>((state) => state.productDetail.modelAgilityId);
  const variantAgilityId = useSelector<RootState, number | null>(
    (state) => state.productDetail.selectedVariantAgilityId,
  );
  const isLoadingDownloads = useSelector<RootState, boolean>((x) => x.productDetail.loadingDownloads);
  const pageContext = useSelector<RootState, PageContext>((state) => state.pageContext);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch<ProductDetailAction>({ type: SET_AVAILABLE_DOWNLOADS_LOADING, payload: true });
    fetchDownloads(
      modelAgilityId,
      variantAgilityId,
      pageContext.documentCulture,
      pageContext.showOnlyPublishedProducts,
    ).then((downloads) => {
      dispatch<ProductDetailAction>({ type: SET_AVAILABLE_DOWNLOADS, payload: downloads });
    });
  }, [variantAgilityId]);

  return isLoadingDownloads;
};
